/**
 * Created by Marcus Zhao on 12/01/2020
 * -------------------------------------
 */

import { Component, OnInit, Input } from '@angular/core';
import { ContactTemplateService } from '../../../contact-dialog-new/contact-template.service';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../redux';
import { ContactTemplateControlValue } from '@tamalelibs/models/contact-template-control-value.model';
import { ChangeContactTemplateValueSet } from '@tamalelibs/redux/contact.actions';
import { ContactTemplateType } from '../../../contact-dialog-new/contact-dialog.model';

@Component({
    selector: 'tam-contact-area',
    templateUrl: './contact-area.component.html',
    styleUrls: ['./contact-area.component.scss'],
    standalone: false
})
export class ContactAreaComponent implements OnInit {
    @Input() childConfig: any;
    inputValue = '';
    config: any;
    constructor(
        private _contactTemplateService: ContactTemplateService,
        private _store: Store<AppState>) {
    }

    ngOnInit() {
        this.config = this.childConfig.config;
        if (this.config.action === ContactTemplateType.EditContact) {
            this._initEditValue();
        }
    }
    /**
     * notes value change
     * @param {*} value
     * @memberof ContactAreaComponent
     */
    textChange(value) {
        this._contactTemplateService.changeValueStatus = true;
        this.changeValueSet(true);
    }

    /**
     * init edit value
     * @private
     * @memberof ContactInputComponent
     */
    private _initEditValue() {
        this.inputValue = this.config.editValue;
        this.changeValueSet(false);
    }

    /**
     * set value to store
     * @param {boolean} isFromUser
     * @memberof ContactAreaComponent
     */
    changeValueSet(isFromUser: boolean) {
        const value = new ContactTemplateControlValue(this.inputValue, this.inputValue, this.config);
        this._store.dispatch(
            new ChangeContactTemplateValueSet(
                value,
                'prefix',
                this.config.prefixId
            )
        );
    }
}
